import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function FeeStructure() { 
  useEffect(() => {
    document.title = 'Staff Members-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Fee Structure</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Fee Structure</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <div class="table-responsive maintable">
               <table class="table">
                   <thead>
                       <tr>
                           <th>Class</th>
                           <th>Registration Fee</th>
                           <th>Composite Fee (Monthly)</th>
                           <th>Admission Fee  ( For New Student)</th>
                           <th>Yearly</th>
                       </tr>
                   </thead>
                    <tbody>
                            <tr>
                            <td>Nur. - U.KG </td>
                            <td>200 </td>
                            <td>4100 </td>
                            <td>7000 </td>
                            <td>56400 </td>
                            </tr>
                            <tr>
                            <td>I - V </td>
                            <td>200 </td>
                            <td>4600 </td>
                            <td>7000 </td>
                            <td>62400 </td>
                            </tr>
                    </tbody>
                </table>
                </div>
              </div> 
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FeeStructure;
